import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import Award1 from '@public/images/newAboutUs/award-1.png';
import Award2 from '@public/images/newAboutUs/award-2.png';
import Award3 from '@public/images/newAboutUs/award-3.png';
import Award4 from '@public/images/newAboutUs/award-4.png';
import Award5 from '@public/images/newAboutUs/award-5.png';
import Award6 from '@public/images/newAboutUs/award-6.png';
import Award7 from '@public/images/newAboutUs/award-7.png';
import Award8 from '@public/images/newAboutUs/award-8.png';
import Excellent from '@public/images/newAboutUs/excellent.png';
import { Autoplay } from 'swiper';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';

import TPLink from '@/components/TPLink';

import { MyContext } from '@/config/context-manager';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const Awards = () => {
  const { t } = useTranslation('aboutus');
  const { locale } = useContext(MyContext);

  const awards = [
    {
      id: 1,
      src: Award1,
      title: t('award-1-title'),
      subTitle: t('award-1-subtitle'),
    },
    {
      id: 2,
      src: Award2,
      title: t('award-2-title'),
      subTitle: t('award-2-subtitle'),
    },
    {
      id: 3,
      src: Award3,
      title: t('award-3-title'),
      subTitle: t('award-3-subtitle'),
    },
    {
      id: 4,
      src: Award4,
      title: t('award-4-title'),
      subTitle: t('award-4-subtitle'),
    },
    {
      id: 5,
      src: Award5,
      title: t('award-5-title'),
      subTitle: t('award-5-subtitle'),
    },
    {
      id: 6,
      src: Award6,
      title: t('award-6-title'),
      subTitle: t('award-6-subtitle'),
    },
    {
      id: 7,
      src: Award7,
      title: t('award-7-title'),
      subTitle: t('award-7-subtitle'),
    },
    {
      id: 8,
      src: Award8,
      title: t('award-8-title'),
      subTitle: t('award-8-subtitle'),
    },
  ];
  return (
    <div className="mx-auto w-full max-w-[984px] bg-[url('/images/newAboutUs/bg-wukong.png')] bg-[100%_auto] bg-top bg-no-repeat py-12 lg:mb-[180px] lg:pt-[180px] xl:mb-[260px] xl:max-w-[1400px]">
      {/* PC端展示 */}
      <div className="hidden grid-cols-4 gap-6 lg:grid xl:gap-12">
        {awards.map((award) => (
          <div
            key={award.id}
            className="flex flex-1 flex-col items-center justify-center rounded-[20px] bg-white/20 p-5 shadow-[0px_8px_20px_0px_rgba(0,0,0,0.06)] lg:p-5 xl:px-8 xl:py-6"
          >
            <Image
              src={award.src}
              alt={award.title}
              width={180}
              height={76.4}
              className="mb-4 xl:h-[93.4] xl:w-[220px]"
            />
            <h3 className="mb-2 text-center font-medium text-gray-800">{award.title}</h3>
            <p className="text-center text-sm text-gray-500">{award.subTitle}</p>
          </div>
        ))}
      </div>

      {/* 移动端轮播 */}
      <div className="lg:hidden lg:h-[5340px] lg:w-[1920px]">
        <Swiper
          modules={[Autoplay]}
          autoplay
          onInit={(swiper: SwiperRef['swiper']) => {
            swiper.el.addEventListener('touchstart touchmove', () => {
              swiper.autoplay?.stop();
            });
            swiper.el.addEventListener('touchend', () => {
              swiper.autoplay?.start();
            });
          }}
          slidesPerView="auto"
          loop
          centeredSlides
          className="[&&]:p-5"
        >
          {awards.map((award) => (
            <SwiperSlide className="mx-2 [&&]:w-[273px]" key={award.id}>
              <div className="flex h-[180px] w-[273px] flex-col items-center justify-center rounded-[20px] bg-white p-5 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.06)]">
                <Image src={award.src} alt={award.title} width={180} height={76.4} className="mb-3" />
                <h3 className="mb-2 text-center font-medium text-gray-800">{award.title}</h3>
                <p className="text-center text-sm text-gray-500">{award.subTitle}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {/* TrustPilot评分 */}
      <TPLink>
        <div className="mt-[40px] flex flex-col items-center justify-center lg:mt-15 lg:flex-row">
          <Image
            src={Excellent}
            alt="Excellent"
            width={354}
            height={33}
            className="mb-3 h-[24px] w-[244px] lg:mb-0 lg:h-[33px] lg:w-[354px]"
          />
          <span className="ml-2 text-[16px] font-medium text-wk-words-1 lg:ml-3 lg:text-[18px] xl:ml-4">
            TrustScore 4.7 {locale === 'zh' && '分'}
          </span>
        </div>
      </TPLink>
    </div>
  );
};

export default Awards;
